export default function () {
  (function ($) {
    $(document).on('forminator:form:submit:success', function (formData) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'contact_form',
      });
    })
  })(jQuery);
};